<template>
  <div id="add-user" class="m-t-10">
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group">
        <label for="input-nama">Query</label>
        <div class="form-group">
          <input
            type="text"
            name="nama"
            value=""
            id="input-query"
            class="form-control"
            placeholder=""
            required
            v-model="query"
          />
        </div>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary">Simpan</button>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";

$.pgNotification = notif;

export default {
  name: "AddQueryTrend",
  props: {
    data: Array,
  },
  data() {
    return {
      query: null,
      id_project: this.$store.getters.user.id_project,
    };
  },
  methods: {
    submitForm: function () {
      if (this.query != null) {
        let params = {
          query: this.$sanitize(this.query),
          _id: this.data[0].idTrend,
        };
        let api = process.env.VUE_APP_API_URL + "newstrend/save-query";
        this.$http
          .post(api, params)
          .then((response) => {
            if (response.status == 200) {
              this.$parent.$parent.getData();
              $("#modalSlideUp").modal("hide");
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> News Trend berhasil ditambahkan!',
                  position: "top",
                  timeout: 5000,
                  type: "success",
                })
                .show();
            }
          })
          .catch(() => {
            $("#modalSlideUp").modal("hide");
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat menambahkan User!',
                position: "top",
                timeout: 5000,
                type: "danger",
              })
              .show();
          });
      } else {
        alert("pastikan semua field terisi");
      }
    },
  },
  mounted: function () {
    this.query = this.data[0].query;
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
}
select {
  cursor: pointer;
}
</style>